import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { interval } from 'rxjs';
import { finalize, map, take } from 'rxjs/operators';
import { ForgetPasswordService } from '../services/forget-password.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarErrorComponent } from '@biz-ui/shared-presenters/custom-snackbar/snackbar-error/snackbar-error.component';

@Component({
	selector: 'app-forgot-password',
	templateUrl: './forgot-password.component.html',
	styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
	constructor(
		private formBuilder: UntypedFormBuilder,
		private forgetpasswordService: ForgetPasswordService,
		private _snackBar: MatSnackBar,
	) {}
	forgetPasswordForm: UntypedFormGroup;
	validated = false;
	empty = false;
	loading = false;
	apiError = false;
	disabled = false;
	retry = false;
	counter = 0;

	ngOnInit(): void {
		this.forgetPasswordForm = this.formBuilder.group({
			email: ['', [Validators.required, Validators.email]],
		});
	}

	onSubmit() {
		this.loading = true;
		this.disabled = true;
		if (this.forgetPasswordForm.controls['email'].invalid) {
			this.forgetPasswordForm.controls['email'].markAsTouched({ onlySelf: true });
			this.loading = false;
			this.disabled = false;
			return;
		}

		this.forgetpasswordService.forgetPassword(this.forgetPasswordForm.value).subscribe(
			(resp: any) => {
				if (resp.code_status == 200 && resp.data) {
					this.validated = true;
					this.loading = false;
					this.apiError = false;
					this.countdown();
					// console.log(resp.data);
				}
			},
			(err: any) => {
				this.loading = false;
				this._snackBar.openFromComponent(SnackbarErrorComponent, {
					data: err.error.message,
					panelClass: 'bg-danger',
					// duration: 3000,
				});
				if (err.error.message == 'Please wait before retrying.') {
					this.countdown();
				} else {
					this.apiError = true;
				}
			},
		);
	}

	countdown() {
		this.retry = true;
		const time = 60;
		const numbers = interval(1000);
		const takeOneMinute = numbers.pipe(
			take(time),
			map((v) => time - 1 - v),
			finalize(() => {
				this.disabled = false;
				this.retry = false;
			}),
		);
		takeOneMinute.subscribe((resp: any) => {
			this.counter = resp;
		});
	}
}
